import { useEffect, useRef } from "react";
import { useGetDashboard, useUpdateDashboard } from "@/hooks";
import { addWidgetToLayout, fromRGLLayouts, toRGLLayouts } from "@/utils/layout-update";
import { COLS } from "../dashboard/dashboard-grid";
import { Layouts } from "react-grid-layout";
import { toast } from "sonner";

export const CommitWidgetLayoutUpdater = ({ widget }: { widget: any }) => {
  const { data: dashboard } = useGetDashboard(widget?.dashboardId);
  const updateDashboardMutation = useUpdateDashboard();
  const hasRun = useRef(false);

  useEffect(() => {
    if (dashboard?.layout && !hasRun.current && widget?.dashboardId) {
      hasRun.current = true;
      const currentLayouts: Layouts = toRGLLayouts(dashboard.layout.layouts);

      const updatedLayouts: Layouts = addWidgetToLayout(
        currentLayouts,
        widget.id.toString(),
        COLS,
        widget.visualizationType
      );

      const updatedPayload = {
        formData: {
          layout: {
            layouts: fromRGLLayouts(updatedLayouts),
            order: [
              ...dashboard.layout.order.map((id: any) => id.toString()),
              widget.id.toString(),
            ],
          },
        },
        id: widget?.dashboardId,
      };

      updateDashboardMutation.mutateAsync(updatedPayload).then(() => {
        console.log("Dashboard layout updated");
      });
    }
  }, [dashboard, widget, updateDashboardMutation]);

  return null;
};
